import { render, staticRenderFns } from "./WapRank.vue?vue&type=template&id=766927ec&scoped=true&"
import script from "./WapRank.vue?vue&type=script&lang=js&"
export * from "./WapRank.vue?vue&type=script&lang=js&"
import style0 from "./WapRank.vue?vue&type=style&index=0&id=766927ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766927ec",
  null
  
)

export default component.exports